import React from 'react';
import { User } from 'firebase';
import { FirestoreCollection } from '@react-firebase/firestore';
import {
  Card,
  CardContent,
  Media,
  MediaLeft,
  MediaContent,
  Title,
  Subtitle,
  Content,
  Columns,
  Column,
  Button
} from 'bloomer';
import Gravatar from 'react-gravatar';
import { Bikes } from './bikes';
import { combineIdsAndValues, firebaseApp } from '../firebase/firebase';
import { useHistory } from 'react-router-dom';
import { navigateTo } from '../nav/nav-top';

export function Riders({ user }: { user: User }) {
  const history = useHistory();
  return (
    <FirestoreCollection path={`/users/${user.uid}/riders`} orderBy={[{ field: 'name' }]}>
      {d =>
        d.isLoading
          ? 'Loading...'
          : d.value
          ? renderRiders(user, combineIdsAndValues(d), history)
          : 'No riders found'
      }
    </FirestoreCollection>
  );
}

function renderRiders(user: User, riders: Rider[], history: ReturnType<typeof useHistory>) {
  return (
    <>
      {riders.length > 0 ? (
        <Columns isMultiline>
          {riders.map(rider => (
            <Column isSize="1/3" key={rider.email}>
              <Card>
                <CardContent>
                  <Media>
                    <MediaLeft>
                      <Gravatar
                        email={rider.email!}
                        size={48}
                        rating="pg"
                        default={'robohash' as any}
                        style={{ borderRadius: '100%', cursor: 'pointer' }}
                        onClick={e => {
                          e.preventDefault();
                          window.open('https://gravatar.com');
                        }}
                      />
                    </MediaLeft>
                    <MediaContent>
                      <Title isSize={6}>{rider.name}</Title>
                      <Subtitle isSize={6}>{rider.email}</Subtitle>
                      <div className="buttons has-addons is-small is-right">
                        <Button
                          isSize="small"
                          onClick={(e: any) => navigateTo(e, history, `/riders/${rider.id}`)}
                        >
                          Edit Rider
                        </Button>
                        <Button
                          isSize="small"
                          onClick={(e: any) => navigateTo(e, history, `/bikes/new/${rider.id}`)}
                        >
                          Add Bike
                        </Button>
                        <Button
                          isSize="small"
                          isColor="danger"
                          onClick={() => {
                            const result = window.confirm(
                              `Are you sure that you want to delete ${rider.name}?`
                            );
                            if (result) deleteRider(user, rider);
                          }}
                        >
                          Delete Rider
                        </Button>
                      </div>
                    </MediaContent>
                  </Media>
                  <Content>
                    <Bikes user={user} rider={rider} />
                  </Content>
                </CardContent>
              </Card>
            </Column>
          ))}
        </Columns>
      ) : (
        <div style={{ margin: '40px 0 20px 0' }}>No riders have been added yet.</div>
      )}
      <Button isColor="primary" isFullWidth onClick={(e: any) => navigateTo(e, history, '/riders/new')}>
        Add New Rider
      </Button>
    </>
  );
}

function deleteRider(user: User, rider: Rider) {
  firebaseApp
    .firestore()
    .doc(`users/${user.uid}/riders/${rider.id}`)
    .update({ deleted: true });
}

export interface Rider {
  id: string;
  email: string;
  name: string;
}
